// import React, { Component } from 'react';
// import { DatePicker } from 'antd';
// import dayjs from 'dayjs';
// import 'antd/dist/reset.css';
// import './Thousandone.css';

// export default class Thousandone extends Component {
//   constructor(props) {
//     super(props);

//     const getDate = () => {
//       const defStr = this.props.defdata;
//       const arr = defStr.split(' ');
//       return arr[0]; 
//     };

//     this.state = {
//       date: getDate() ? dayjs(getDate(), 'YYYY-MM-DD') : null, 
//     };

//     this.storeDate = this.storeDate.bind(this);
//   }

//   storeDate(date, dateString) {
   
//     if (dateString) {
//       const fullDate = dateString + ' 00:00:00.000';
//       this.props.onChange(fullDate);
//       this.setState({ date });
//     } else {
//       this.setState({ date: null });
//       this.props.onChange('');
//     }
//   }

//   render() {
//     console.log(this.props.defdata,"his.props.defdata")
//     const style = {
//       width: '100%',
//       padding: '6px',
//       marginBottom: '15px',
//       cursor:"pointer",
//       zIndex:999
//     };

//     return (
//       <div className='form-group' style={{ paddingBottom: '10px' }}>
//         <label style={{ fontWeight: '600', fontSize: '18px' }}>Select Date</label>
//         <DatePicker
//           style={style}
//           value={this.state.date}
//           onChange={this.storeDate}
      
//           format="DD MMMM YYYY"
//           allowClear={false}
//             getPopupContainer={() => document.body}
//   popupClassName="ant-picker-popup-fix"
//           // getPopupContainer={(triggerNode) => triggerNode.parentNode}
   
//           dropdownStyle={{ zIndex: 20000 }}
//         />
//       </div>
//     );
//   }
// }

import React, { Component } from 'react';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import 'antd/dist/reset.css';
import './Thousandone.css';
import { showCustomSwal } from '../../customswal/Customswal';


export default class Thousandone extends Component {
  constructor(props) {
    super(props);

    const getDate = () => {
      const defStr = this.props.defdata;
      const arr = defStr.split(' ');
      return arr[0]; 
    };

    this.state = {
      date: getDate() ? dayjs(getDate(), 'YYYY-MM-DD') : null, 
      defaultpreviousdate:this.props.defaultpreviousdate
    };

    this.storeDate = this.storeDate.bind(this);
  }


storeDate(date) {
  if(this.props.defaultpreviousdate){
 if (date) {
    const fullDate = dayjs(date).format("YYYY-MM-DD 00:00:00.000");
    const today = dayjs().startOf("day");

    const isDefaultSelected = this.props.defaultpreviousdate
      ? dayjs(date).isSame(dayjs(this.props.defaultpreviousdate), "day")
      : false;

    if (dayjs(date).isBefore(today, "day") && !isDefaultSelected) {
      showCustomSwal("You have selected a past date. Action not allowed.");
    } else {
      this.setState({ date });
      this.props.onChange(fullDate);
    }
  } else {
    this.setState({ date: null });
    this.props.onChange("");
  }
  }else{
    if (date) {
      const fullDate = dayjs(date).format("YYYY-MM-DD 00:00:00.000");
      this.props.onChange(fullDate);
      this.setState({ date });
    } else {
      this.setState({ date: null });
      this.props.onChange('');
    }
  }
 

}

  render() {
    console.log(this.props.defdata,"his.props.defdata")
    const style = {
      width: '100%',
      padding: '6px',
      marginBottom: '15px',
      cursor:"pointer",
      zIndex:999
    };

    return (
      <div className='form-group' style={{ paddingBottom: '10px' }}>
        <label style={{ fontWeight: '600', fontSize: '15px' }}>Select Date</label>
        <DatePicker
          style={style}
          value={this.state.date}
          onChange={this.storeDate}
          format="DD MMMM YYYY"
          allowClear={false}
            getPopupContainer={() => document.body}
  popupClassName="ant-picker-popup-fix"
          dropdownStyle={{ zIndex: 20000 }}
        />
      </div>
    );
  }
}